module.exports = __webpack_public_path__ + "img/private01.8510395d.jpg";